import CardCondition from '@/components/CardCondition';
import LocationConditionItem from '@/components/LocationRuleCondition/LocationConditionItem';
import { LocationRuleConditionStyled } from '@/components/LocationRuleCondition/styled';
import useUserPlan from '@/hooks/useUserPlan';
import { IConditionValue, IItemCondition, ILocationCondition } from '@/types/newSetup.type';
import { LocationIcon } from '@shopify/polaris-icons';

interface IProps {
  onAction: () => void;
  data: ILocationCondition[];
  onChange: (key: IItemCondition['type'] | ILocationCondition['type']) => (value: IConditionValue[] | null) => void;
  onRemove: (condition: IItemCondition['type'] | ILocationCondition['type']) => void;
  isInCheckout?: boolean;
}

const LocationRuleCondition = ({ onAction, data, onChange, onRemove, isInCheckout }: IProps) => {
  const { isPlanLimited } = useUserPlan();
  return (
    <LocationRuleConditionStyled>
      <CardCondition
        icon={LocationIcon}
        title="Location conditions"
        badgeContent={isPlanLimited ? null : `${data?.length} condition${data?.length > 1 ? 's' : ''}`}
        badgeTone={isPlanLimited ? 'info' : undefined}
        subTitle="Rule for specific regions, countries, states, zipcodes"
        buttonText="Add condition"
        onAction={onAction}
        collapsible={data.length > 0}
        defaultExpanded={data.length > 0}
        isShowButtonOnBottom
        textLimitedPlan={isPlanLimited && 'Pro'}
      >
        <LocationConditionItem data={data} onChange={onChange} onRemove={onRemove} isInCheckout={isInCheckout} />
      </CardCondition>
    </LocationRuleConditionStyled>
  );
};

export default LocationRuleCondition;
